export enum Role {
  Admin = "admin",

  Employee = "employee",
  Patient = "patient",

  OrganizationAdmin = "organization_admin",
  OrganizationManager = "organization_manager",

  LocationManager = "location_manager",
  Secretary = "secretary",
  Backoffice = "backoffice",
  Physio = "physiotherapist",
  QualityManager = "quality_manager",
  AlphaUser = "alpha_user",
  BetaUser = "beta_user",
}

export type PractitionerRoleType = Exclude<Role, Role.Admin | Role.Employee | Role.Patient | Role.AlphaUser | Role.BetaUser>;
export type FeatureGrant = Role.AlphaUser | Role.BetaUser;
